import React from 'react';
import { Box } from '@wix/design-system';
import { PageHeader } from '@wix/app-market-components';
import {
  useServices,
  useSiteContext,
  QueryDecorator,
} from '@wix/app-market-core';
import { CollectionHeaderSkeleton } from './collection-header-skeleton';
import { getCollectionPageHeaderData } from './collection-page-data';
import type { CollectionPageHeaderProps } from './collection-page-data';

function CollectionPageHeaderComponent({
  primaryTitle,
  secondaryTitle,
  description,
}: CollectionPageHeaderProps) {
  return (
    <Box dataHook="collection-page-header" marginTop="18px">
      <PageHeader
        primaryTitle={secondaryTitle}
        secondaryTitle={primaryTitle}
        description={description}
      />
    </Box>
  );
}

export function CollectionHeader({ slug }: { slug: string }) {
  const { languageCode } = useSiteContext();
  const services = useServices();

  return (
    <QueryDecorator
      queryFn={() =>
        getCollectionPageHeaderData({
          services,
          slug,
          languageCode,
        })
      }
      queryKey={`collection-header-${languageCode}-${slug}`}
    >
      {({ data: collectionPageData, isLoading }) =>
        isLoading ? (
          <CollectionHeaderSkeleton />
        ) : (
          <CollectionPageHeaderComponent
            primaryTitle={collectionPageData.primaryTitle}
            secondaryTitle={collectionPageData.secondaryTitle}
            description={collectionPageData.description}
            slug={slug}
          />
        )
      }
    </QueryDecorator>
  );
}
